import React from 'react'

import FormError from "../../../../../../../core/gd-form/common/form-error/form-error"
import FormManager from "../../../../../../../core/gd-form/common/form-manager"
import CustomView_rowComponent from "./row-component"
import {UserCondition} from "../../../../../../../core/views/@const"

// @ts-ignore
import SelectUser from '../../../../../../../core/gd-ui/select-user/select-user'

type AdditionalUserOption = {
    id      : ID
    name    : string
}

type Props = {
    label                       : string

    form                    : FormManager
    formFieldName           : string

    usersIds                : ID[]
    additionalUsersOptions? : AdditionalUserOption[]

    includeCurrentUser?     : boolean
    disabled?               : boolean
}

export default function SelectUsersMulti(props: Props) {

    let additionalUsersOptions: AdditionalUserOption[] = []
    if (props.includeCurrentUser) {
        additionalUsersOptions.push({
            id      : UserCondition.CURRENT_USER, //backend should understand this id
            name    : 'Current user'
        })
    }

    additionalUsersOptions = _.unionBy(additionalUsersOptions, props.additionalUsersOptions, (option: AdditionalUserOption) => {
        return option.id
    })

    return (
        <CustomView_rowComponent label={props.label}>
            <SelectUser className           = "w-300"
                        form                = {props.form}
                        name                = {props.formFieldName}
                        multiselect         = {true}
                        options             = {props.usersIds}
                        additionalOptions   = {additionalUsersOptions}
                        renderValue         = "form"
                        underlined          = "always"
                        placeholder         = "All users"
                        canHaveNoValue      = {true}
                        noValueValue        = {[]}
                        noValueLabel        = "All users"
                        disabled            = {props.disabled}/>
            <FormError form = {props.form}
                       name = {props.formFieldName}/>
        </CustomView_rowComponent>
    )
}